const $ = require("jquery")
const moment = require("moment")

const Barba = require('@barba/core')
const start = async function() {
    const checkOverlap = require("check-element-overlap");

    try {

        $(".scroll").on('click',function (event) {
            event.preventDefault();
            $('html,body').animate({
                scrollTop: $(this.hash).offset().top
            }, 150);
        });

        await setTimeout(async () => {

            document.body.style.overflow = 'auto';
            document.body.classList.remove("menuOppened");
            closeOthers()

            var whiteElements = Array.from(document.getElementsByClassName("enableBlackMenu"))




            function getPositions(elem) {
                var pos, width, height;
                pos = $(elem).offset();
                width = $(elem).width() / 2;
                height = $(elem).height();
                return [
                    [pos.left, pos.left + width],
                    [pos.top, pos.top + height]
                ];
            }

            function comparePositions(p1, p2) {
                var r1, r2;
                r1 = p1[0] < p2[0] ? p1 : p2;
                r2 = p1[0] < p2[0] ? p2 : p1;
                return r1[1] > r2[0] || r1[0] === r2[0];
            }

            function overlaps(a, b) {
                var pos1 = getPositions(a),
                    pos2 = getPositions(b);
                return comparePositions(pos1[0], pos2[0]) && comparePositions(pos1[1], pos2[1]);
            };

            // whiteElements.
            // document.getElementsByClassName("nav")[0], )

            // backtoHome();
            if (isSafari() == false) {
                var prevScrollpos = window.pageYOffset;
                currentScrollPos = 0;
                document.getElementById("header")
                    .classList.remove("docked");

                window.onscroll = function() {
                    var currentScrollPos = window.pageYOffset;
                    if (currentScrollPos > 90) {
                        document.getElementById("header").classList.add("docked");
                    } else {
                        document.getElementById("header").classList.remove("docked");
                    }
                    //prevScrollpos = currentScrollPos;
                    // console.log(currentScrollPos)
                }
            }

            Array.from(document.getElementsByClassName("openMenuAction"))
                .forEach((item, i) => {
                    item.addEventListener("click", async (_e) => await openMenu(item))
                });
            try {



            } catch (err) {
                console.log('err', err)
            }

            // remove instagram error photos
            // var instagramContainer = document.getElementsByClassName("instagramContainer")
            // instagramContainer = instagramContainer[0]
            //
            // instagramContainer = Array.from(instagramContainer.getElementsByClassName("item"))
            //
            //
            // instagramContainer.forEach((item) => {
            //     var imageEl = item.getElementsByTagName("img")
            //     imageEl = imageEl[0]
            //     if (!IsImageOk(imageEl)) {
            //         item.remove();
            //     }
            // })

        }, 200);
    } catch (err) {
        console.log('err', err)
    }


    return true


}


function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            return false
        } else {
            return true
        }
    }
}

function IsImageOk(img) {
    // During the onload event, IE correctly identifies any images that
    // weren't downloaded as not complete. Others should too. Gecko-based
    // browsers act like NS4 in that they report this incorrectly.
    if (!img.complete) {
        return false;
    }

    // However, they do have two very useful properties: naturalWidth and
    // naturalHeight. These give the true size of the image. If it failed
    // to load, either of these should be zero.
    if (typeof img.naturalWidth != "undefined" && img.naturalWidth == 0) {
        return false;
    }

    // No other way of checking: assume it's ok.
    return true;
}



async function openMenu(element) {


    try {
        var menuID = element.getAttribute('menuID')

        if (menuID) {
            if (menuID == "hamburger") {
                const hamburgerEl = document
                    .getElementById("hamburger")
                const menuEl = document
                    .getElementById("hamburgerMenu")
                const hideNavLink = document
                    .getElementById("navLinks")

                if (menuEl.classList.contains("oppened")) {
                    menuEl.classList
                        .remove("oppened")
                    hamburgerEl
                        .classList
                        .remove("is-active")
                    document.body.style.overflow = 'auto';
                    document.body.classList.remove("menuOppened");
                    if (hideNavLink) {
                        hideNavLink
                            .classList
                            .remove("active")
                    }


                } else {
                    closeOthers()
                    menuEl.classList
                        .add("oppened")
                    hamburgerEl
                        .classList
                        .add("is-active")
                    if (hideNavLink) {
                        hideNavLink
                            .classList
                            .add("active")
                    }

                    document.body.style.overflow = 'hidden';
                    document.body.classList.add("menuOppened");

                }
            } else {

                const menuEl = document
                    .getElementById(menuID)
                const menuItem = document
                    .getElementById(`${menuID}_menuitem`)

                if (menuEl && menuEl.classList.contains("oppened")) {

                    menuEl.classList
                        .remove("oppened")

                    if (menuItem) {
                        menuItem.classList
                            .remove("oppened");
                    }
                    closeOthers()
                    document.body.style.overflow = 'auto';
                    document.body.classList.remove("menuOppened");
                } else {
                    closeOthers()
                    const hamburgerEl = document
                        .getElementById("hamburgerMenu")


                    if (hamburgerEl.classList.contains("oppened")) {
                        hamburgerEl
                            .classList
                            .remove("oppened")
                    }

                    menuEl.classList
                        .add("oppened")



                    if (menuItem) {
                        menuItem
                            .classList
                            .add("oppened");
                    }
                    document.body.style.overflow = 'hidden';
                    document.body.classList.add("menuOppened");
                }
            }
        } else {
            document.body.style.overflow = 'auto';
            document.body.classList.remove("menuOppened");
            return
        }
    } catch (err) {
        console.log('errMenu', err)
    }


}

function closeOthers() {
    const classesToRemove = ['oppened', 'is-active']

    classesToRemove.forEach((className) => [
        Array.from(document.getElementsByClassName(className))
        .forEach((element) => {
            element.classList
                .remove(className)
        })
    ])
}


module.exports = {
    start: start
};
